import { Link } from 'react-router-dom';

export default function ArticlePreview() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-10 md:gap-12 items-center">
            <div className="lg:col-span-2">
              <div className="relative rounded-lg overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Elegant%20minimal%20digital%20spreadsheet%20directory%20layout%20on%20cream%20colored%20screen%2C%20organized%20product%20cards%20with%20soft%20sage%20green%20accents%2C%20clean%20editorial%20design%2C%20Scandinavian%20UI%20aesthetic%2C%20airy%20atmosphere%2C%20professional%20catalog&width=800&height=1000&seq=guide-preview-v3&orientation=portrait"
                  alt="Vigorbuy Spreadsheet Guide"
                  className="w-full h-auto object-cover rounded-lg"
                  loading="lazy"
                />
              </div>
            </div>

            <div className="lg:col-span-3">
              <span className="inline-block px-4 py-1.5 border border-primary-300 text-primary-700 rounded-full text-xs font-semibold uppercase tracking-wider mb-4">
                Featured Guide
              </span>
              <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-900 leading-tight">
                Best Vigorbuy Spreadsheet 2026
              </h2>
              <p className="mt-4 text-foreground-600 leading-relaxed max-w-xl">
                Everything you need to know about using the Vigorbuy Spreadsheet — from finding trusted sellers and verifying products to understanding QC photos and optimizing shipping.
              </p>
              <p className="mt-3 text-foreground-600 leading-relaxed max-w-xl">
                Whether you are a first-time buyer or an experienced shopper, our guide helps you navigate the directory efficiently and make confident purchasing decisions.
              </p>
              <div className="mt-6">
                <Link
                  to="/guide/vigorbuy-spreadsheet-guide"
                  className="inline-flex items-center gap-2 px-7 py-3 bg-foreground-900 text-background-50 rounded-full text-sm font-semibold hover:bg-foreground-800 transition-all duration-200 whitespace-nowrap group cursor-pointer"
                >
                  Read Full Guide
                  <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform duration-200"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}